import { type ForwardedRef, forwardRef, type HTMLProps } from 'react';

import { cn } from '@/lib/cn';

export const ValueWrapper = forwardRef(
  (
    { children, ...props }: HTMLProps<HTMLDivElement>,
    ref?: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div
        {...props}
        className={cn(
          'flex w-fit min-h-4 py-1 px-1 rounded justify-center items-center gap-1 hover:bg-gray-200 transition-all duration-200 text-xs',
          props.className,
        )}
        ref={ref}
      >
        {children}
      </div>
    );
  },
);
